<script setup>
import { ref } from 'vue'
import { register_user } from '../services/auth'
import { useRouter } from 'vue-router';
import { swalError } from '@/helper';
const router = useRouter()

const active = ref(true)
const user = ref({})
const agreement = ref()
function show (){
  active.value = !active.value
}

const loading = ref(false)
async function registering (){
  loading.value = true
  const response = await register_user(user.value)
  loading.value = false
  if (response.error){
    let error_type = Object.keys(response.result.errors)
    let errors = ''
    let count = 1
    error_type.forEach((message) => {
      errors += `${count}. ${message[0].toUpperCase() + message.slice(1)} ${response.result.errors[message]}<br/>`
      count++
    })

    Swal.fire({
      title: 'Error',
      html: errors,
      icon: 'error'
    })
  }else{
    if (response.result.user_type == 'customer'){
      localStorage.setItem('user_data', JSON.stringify(response.result))
      router.push({name: 'dashboard'})
    }else{
      swalError('Admin should not be here')
    }
  }
}
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xl-7 b-center bg-size p-0" :style="{ backgroundImage: 'url('+ require('../assets/images/login/login.png') +')' }" style="background-color: #f8f9ff; background-size: cover; background-position: center center; display: block;">
      </div>
      <div class="col-xl-5 p-0">
        <div class="login-card">
          <div>
            <div>
              <a class="logo">
                <img class="img-fluid" src="../assets/images/logo/logo.png" width="200" alt="looginpage" />
              </a>
            </div>
            <div class="login-main ">
              <form class="theme-form" @submit.prevent="registering">
                <h4>Create your account</h4>
                <p>Enter your personal details to create account</p>
                <div class="form-group">
                  <label class="col-form-label pt-0">Your Name</label>
                  <div class="row g-2">
                    <div class="col-6">
                      <input class="form-control" type="text" required="" placeholder="First name" v-model="user.first_name" />
                    </div>
                    <div class="col-6">
                      <input class="form-control" type="text" required="" placeholder="Last name" v-model="user.last_name"/>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Email Address</label>
                  <input class="form-control" type="email" required="" placeholder="Test@gmail.com" v-model="user.email"/>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Password</label>
                  <div class="form-input position-relative">
                    
                    <input class="form-control" :type="active?'password':'text'" name="login[password]" required="" placeholder="*********" v-model="user.password"/>
                    <div class="show-hide"><span :class="active?'show':'hide'" @click.prevent="show"> </span></div>
                  </div>
                </div>
                <div class="form-group mb-0">
                  <div class="checkbox p-0">
                    <input id="checkbox1" type="checkbox" v-model="agreement" />
                    <label class="text-muted" for="checkbox1">Agree with<router-link class="ms-2" to="/privacy-policy" target="_blank">Privacy Policy</router-link></label>
                  </div>
                  <button type="submit" class="btn btn-primary btn-block" :disabled="!agreement">
                    <span v-if="loading">
                      <div class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </span>
                    <span v-else>
                      Create Account
                    </span>
                  </button>
                </div>
                <!-- <h6 class="text-muted mt-4 or">Or signup with</h6>
                <div class="social mt-4">
                  <div class="btn-showcase">
                    <a class="btn btn-light" href="#" target="_blank">
                      <img class="bg-img-cover bg-center" src="../assets/images/facebook.png" width="18" alt="google" />
                      Facebook
                    </a>
                    <a class="btn btn-light" href="#" target="_blank">
                      <img class="bg-img-cover bg-center" src="../assets/images/google.png" width="15" alt="google" />
                      Google
                    </a>
                  </div>
                </div> -->
                <p class="mt-4 mb-0">
                  Already have an account?
                  <router-link class="ms-2" tag="a" :to="{name: 'login'}">
                    Login
                  </router-link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>